__turbopack_context__.v({
  "input": "x-o31W_input",
  "root": "x-o31W_root",
  "textarea": "x-o31W_textarea",
});
